import PropTypes from 'prop-types';
import React from 'react';
import BasicLangChip from '../../core/BasicLangChip';
import withGS from '../../core/withGShoc';
import GS from '../../grafsync/grafsync';

const loadOptions = {};

class SelectResourceLink extends React.Component {

    handleDeleteLink = () => GS.deleteProperty(this.props.source, this.props.graph, this.props.property, this.props.id);

    render() {

        const { data, defaultLang, viewLang, id, isReadOnly, canDelete, selectResource } = this.props;


        return (
            <BasicLangChip
                id={id}
                viewLang={viewLang}
                deprecated={data.deprecated}
                isReadOnly={isReadOnly}
                invalid={data.pendingDeletion}
                defaultLang={defaultLang}
                canDelete={canDelete}
                onClick={selectResource && !data.pendingDeletion ? selectResource : null}
                onDelete={!isReadOnly && canDelete ? this.handleDeleteLink : null}
                label={data.label || data.title} />
        );
    }
}

SelectResourceLink.defaultProps = {
    canDelete: false
};

SelectResourceLink.propTypes = {
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    isReadOnly: PropTypes.bool,
    selectResource: PropTypes.func,
    property: PropTypes.string,
    canDelete: PropTypes.bool,
    source: PropTypes.string,
    graph: PropTypes.string.isRequired,
    viewLang: PropTypes.string,
    defaultLang: PropTypes.string.isRequired
};

export default withGS(SelectResourceLink, ["ALL"], ["id", "label", "deprecated", "title", "pendingDeletion"], loadOptions);